import dayjs from 'dayjs';

import {FakesCreateReportFormEnum} from './fakes-create-report-type';

export const initialValues = {
    [FakesCreateReportFormEnum.DateRange]: [dayjs().subtract(2, 'months'), dayjs().subtract(1, 'months')],
};
